// extracted by mini-css-extract-plugin
export default {"outer":"InfoButton_outer__rofC5","topRight":"InfoButton_topRight__P0Npn","topLeft":"InfoButton_topLeft__ppamh","content":"InfoButton_content__jjdFM"};